import ShoppingBagIcon from "assets/icons/shoppingBag.svg"
import { useLayoutContext } from "client/components/layout"
import {
  Plugin,
  useGlobalContext,
} from "client/packages/utils/GlobalContext"
import ChevronCloseButton from "shared/components/buttons/ChevronCloseButton"
import { RozyLayout } from "shared/constants/views"
import { buttonDisabled, buttonFocus } from "shared/styles/mixins"
import styled from "styled-components"

import { useCartContext } from "../cart/CartContext"
import QuantityIndicator from "../ui/QuantityIndicator"

export const Header = styled.header`
  background-color: ${(props) => props.theme.backgroundShade};
  width: 100%;
  height: ${(props) => props.theme.commerce.headerHeight};
  padding: 0px 15px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  line-height: normal;
  z-index: 2;
  top: 0;
  font-family: ${(props) => props.theme.font.primary};
  border-bottom: 1px solid ${(props) => props.theme.colors.neutralDark};
  flex-shrink: 0;
`

const CartButton = styled.button.attrs({ type: "button" })`
  height: 34px;
  width: 34px;
  position: relative;
  border: none;
  background-color: transparent;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
  border-radius: 3px;
  margin-right: 5px;
  margin-left: auto;

  svg {
    height: 100%;
    width: 100%;
  }

  ${buttonDisabled}

  ${buttonFocus}
`

type ProductHeaderBaseProps = {
  showCart?: () => void
  numItemsInCart: number
  onClose?: () => void | null
}

export function ProductHeaderBase({
  showCart,
  numItemsInCart,
  onClose,
}: ProductHeaderBaseProps) {
  return (
    <Header>
      {onClose && <ChevronCloseButton onClose={onClose} size={21} />}
      <CartButton aria-label="Cart" onClick={showCart}>
        <ShoppingBagIcon />
        {numItemsInCart >= 1 && (
          <QuantityIndicator quantity={numItemsInCart} />
        )}
      </CartButton>
    </Header>
  )
}

export type ProductHeaderProps = {
  showCart?: () => void
}

const ProductHeader = ({ showCart = () => {} }: ProductHeaderProps) => {
  const { cart } = useCartContext()
  const { setPluginOpen } = useGlobalContext()

  const { layout } = useLayoutContext()
  const isPanelClosable = layout === RozyLayout.MOBILE

  const handleClose = () => {
    setPluginOpen(Plugin.COMMERCE, false)
  }

  return (
    <ProductHeaderBase
      showCart={showCart}
      numItemsInCart={cart?.totalQuantity ?? 0}
      onClose={isPanelClosable ? handleClose : null}
    />
  )
}

export default ProductHeader
